import { useParams } from "react-router-dom";
import { useEffect, useState, lazy, Suspense } from "react";
import axios from "axios";
import logo from "./assets/logo.png";
import { deriveOrderStatus, isUndeliverableEvents } from "./statusLogic";
//import ProgressTimeline from "./components/ProgressTimeline";
//import OrderVerticalTimeline from "./components/OrderVerticalTimeline";
//import RecommendedProducts from "./components/RecommendedProducts";
//import OrderDelivered from "./components/OrderDelivered";
import ErrorPage from "./components/ErrorPage";
const LazyRecommendedProducts = lazy(
  () => import("./components/RecommendedProducts"),
);
const LazyProgressTimeline = lazy(
  () => import("./components/ProgressTimeline"),
);
const LazyOrderVerticalTimeline = lazy(
  () => import("./components/OrderVerticalTimeline"),
);
const LazyOrderVerticalTimelineUps = lazy(
  () => import("./components/OrderVerticalTimelineUps"),
);
const LazyProgressTimelineUps = lazy(
  () => import("./components/ProgressTimelineUPS"),
);
const LazyOrderDelivered = lazy(() => import("./components/OrderDelivered"));
export default function OrderTracking() {
  const { orderId, key } = useParams();
  const [events, setEvents] = useState([]);
  const [dst, setDst] = useState(null);
  const [orderNumber, setOrderNumber] = useState("");
  const [status, setStatus] = useState("");
  const [city, setCity] = useState("");
  const [courierId, setCourier] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentStage, setCurrentStage] = useState(0);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [error, setError] = useState(false);
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 768);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    async function fetchOrder(orderId) {
      let res;
      try {
        const encodedOrderId = encodeURIComponent(orderId);
        if (key !== undefined) {
          const encodedKey = encodeURIComponent(key);
          res = await axios.get(
            `${process.env.REACT_APP_AWS_root_url}/orders?id=${encodedOrderId}&key=${encodedKey}`,
          );
        } else {
          res = await axios.get(
            `${process.env.REACT_APP_AWS_root_url}/orders?id=${encodedOrderId}`,
          );
        }
        if (res && res.status !== 200) {
          setError(true);
          return;
        }
        const data = res.data;

        let fetchedEvents = [];
        if (data.events) {
          try {
            fetchedEvents = JSON.parse(data.events).sort((a, b) =>
              a.timestamp.localeCompare(b.timestamp),
            );
          } catch (err) {
            console.error("Failed to parse events:", err);
          }
        }

        const orderNumber = data.orderNumber;
        const status = data.status;
        const city = data.city;
        const courierId = data.courierMeta.value;
        const dst = data.dst.value;

        setEvents(Array.isArray(fetchedEvents) ? fetchedEvents : []);
        setOrderNumber(orderNumber);
        setStatus(status);
        setCity(city);
        setCourier(courierId);
        setDst(dst);
        setCurrentStage(deriveOrderStatus(fetchedEvents, courierId).stage);
      } catch (err) {
        console.error(err);
        setError(true);
      } finally {
        setLoading(false);
      }
    }
    fetchOrder(orderId);
  }, [orderId, key]);

  if (loading)
    return <p style={{ textAlign: "center", marginTop: "50px" }}>Loading...</p>;
  if (error)
    return (
      <div>
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <a href="https://mangalorestore.in/" target="_blank" rel="noreferrer">
            <img
              src={logo}
              alt="Company Logo"
              style={{ width: isMobile ? "180px" : "350px" }}
            />
          </a>
        </div>
        <ErrorPage />
      </div>
    );

  const isDelivered = currentStage === 3;

  const isUndeliverable = isUndeliverableEvents(events);
  const content = isDelivered ? (
    <Suspense fallback={<div>Loading...</div>}>
      <LazyOrderDelivered
        orderNumber={orderNumber}
        trackingEvents={events}
        courierId={courierId}
      />
    </Suspense>
  ) : isMobile ? (
    <div style={{ maxWidth: "650px", margin: "0 auto" }}>
      <Suspense fallback={<div>Loading...</div>}>
        {isUndeliverable ? (
          <LazyProgressTimelineUps
            status={status}
            orderNumber={orderNumber}
            destinationCity={city || "Destination"}
            events={events}
            courierId={courierId}
            dst={dst}
          />
        ) : (
          <LazyProgressTimeline
            status={
              events.length > 0
                ? events[events.length - 1].event
                : status.toUpperCase()
            }
            orderNumber={orderNumber}
            destinationCity={city || "Destination"}
            events={events}
            courierId={courierId}
            dst={dst}
          />
        )}
      </Suspense>

      <div style={{ marginTop: "30px" }}>
        <Suspense fallback={<div>Loading products...</div>}>
          <LazyRecommendedProducts />
        </Suspense>
      </div>

      <div style={{ marginTop: "30px" }}>
        <Suspense fallback={<div>Loading...</div>}>
          {isUndeliverable ? (
            <LazyOrderVerticalTimelineUps
              events={events}
              courierId={courierId}
            />
          ) : (
            <LazyOrderVerticalTimeline events={events} courierId={courierId} />
          )}
        </Suspense>
      </div>
    </div>
  ) : (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexWrap: "wrap",
        gap: "40px",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "0 40px",
      }}
    >
      {/* Left Column */}
      <div style={{ flex: "2 1 650px", minWidth: "650px" }}>
        <Suspense fallback={<div>Loading products...</div>}>
          {isUndeliverable ? (
            <LazyProgressTimelineUps
              status={status}
              orderNumber={orderNumber}
              destinationCity={city || "Destination"}
              events={events}
              courierId={courierId}
              dst={dst}
            />
          ) : (
            <LazyProgressTimeline
              status={
                events.length > 0
                  ? events[events.length - 1].event
                  : status.toUpperCase()
              }
              orderNumber={orderNumber}
              destinationCity={city || "Destination"}
              events={events}
              courierId={courierId}
              dst={dst}
            />
          )}
        </Suspense>

        <div style={{ marginTop: "40px" }}>
          <Suspense fallback={<div>Loading...</div>}>
            {isUndeliverable ? (
              <LazyOrderVerticalTimelineUps
                events={events}
                courierId={courierId}
              />
            ) : (
              <LazyOrderVerticalTimeline
                events={events}
                courierId={courierId}
              />
            )}
          </Suspense>
        </div>
      </div>

      {/* Right Column */}
      <div style={{ flex: "1 1 300px", minWidth: "300px", marginTop: "20px" }}>
        <Suspense fallback={<div>Loading products...</div>}>
          <LazyRecommendedProducts />
        </Suspense>
      </div>
    </div>
  );

  return (
    <div
      style={{
        backgroundColor: "#ecececff",
        minHeight: "100vh",
        padding: "50px 20px",
        fontFamily: "Arial",
      }}
    >
      {/* Logo */}
      <div style={{ textAlign: "center", marginBottom: "0px" }}>
        <a href="https://mangalorestore.in" target="_blank" rel="noreferrer">
          <img
            src={logo}
            alt="Company Logo"
            style={{ width: isMobile ? "250px" : "350px" }}
          />
        </a>
      </div>

      {content}
    </div>
  );
}
